import { EmptyObject } from 'libs/end-to-end/src/generic';
import { CustomVizDefinition } from 'libs/end-to-end/src/custom-viz-definition';
import { SuccessPhenotypeV2Result } from 'libs/end-to-end/src/success-phenotype';
import { SuccessTraitsFinalOutputFile } from 'libs/end-to-end/src/success-phenotype';

export const SuccessPhenotypeV2CustomVizDefinition: CustomVizDefinition = {
  customVizId: 'successPhenotypeV2',
  outputFileName: SuccessTraitsFinalOutputFile,
  isDataQueuingAllowed: true,
  outputSchema: SuccessPhenotypeV2Result,
  extrasSchema: EmptyObject,
  resolveFocusArea: () => 'Performance',
  resolveFilters: (request) => {
    if (request.customVizId !== 'successPhenotypeV2') {
      throw new Error('Invalid custom viz ID');
    }
    return request.inputs.extras.filters;
  },
  resolveAnalysisName: () => undefined,
  checkEnoughDataStateEnabledGate: false,
  eventProperties: (request) => {
    if (request.customVizId !== 'successPhenotypeV2') {
      throw new Error('Invalid custom viz ID');
    }
    return {
      'Custom Viz Type': request.customVizId,
      Filters: request.inputs.extras.filters,
      'Selected Dimensions': [],
      'Selected Metrics': [request.inputs.extras.metric],
      'Selected Focus Areas': [],
    };
  },
  getUrlPath: () => 'success-factors',
};
